import { useEffect, useState } from 'react';
import { IDataProvider } from '@vivli/features/data-requests/infrastructure/interface';

import { first } from 'rxjs/operators';
import { useDataRequestsApiContext } from '@vivli/core/infrastructure/context';

export function useDataRequestProviders(dataRequestId: string, isInProcess: boolean) {
    const [dataProviders, setDataProviders] = useState<IDataProvider[]>();

    const dataRequestsService = useDataRequestsApiContext();

    useEffect(() => {
        if (!dataRequestId) {
            return;
        }

        const sub = dataRequestsService.getDataProviders(dataRequestId, isInProcess).pipe(first()).subscribe(setDataProviders);

        return () => {
            sub.unsubscribe();
        };
    }, [dataRequestId]);

    return dataProviders;
}
